import { http, HttpResponse } from 'msw';
import { UiApiPaths } from '../../../slices/account-api.slice';
import { apiUrl } from '../apiUrl';

const mockSendLogMutation = http.post(apiUrl(UiApiPaths.logs), () => HttpResponse.json());
const mockSendStatsMutation = http.post(apiUrl(UiApiPaths.stats), () => HttpResponse.json());
const mockSendMetricsMutation = http.post(apiUrl(UiApiPaths.metrics), () => HttpResponse.json());

export const loggingHandlers = [mockSendLogMutation, mockSendStatsMutation, mockSendMetricsMutation];
